import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CCRContactDto } from '../dtos/ccrcontact.model';

@Injectable()
export class CCRContactService {
    public newContactAdded: Subject<any>;
    constructor(private apiService: ApiService,
       private router: Router) {
        this.newContactAdded = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getContacts(params?: any): Observable<ApiResponse<ApiPagedResponse<CCRContactDto>>> {
        return this.apiService.get<ApiPagedResponse<CCRContactDto>>('ccrcontact', params);
    }

    getContactDetails(id) {
        return this.apiService.get(`ccrcontact/edit/${id}`);
    }

    saveContact(params?: CCRContactDto) {
        return this.apiService.post(`ccrcontact`, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/ccrcontact.service.ts